'use strict';

import quickView from './quickView';

export default {
    showQuickview: quickView.showQuickview,
    focusQuickview: quickView.focusQuickview,
    trapQuickviewFocus: quickView.trapQuickviewFocus,
    hideDialog: quickView.hideDialog,
    updateAttribute: quickView.updateAttribute,
    updateAddToCart: quickView.updateAddToCart,
    updateAvailability: quickView.updateAvailability
};
